/**
 * login
 */

export default [{
  name: 'jobLevel',
  path: '/jobLevel',
  meta: {
    title: '岗位管理',
    href: '/jobLevel',
    redirect: 'noredirect'
  },
  component: () => import( /* webpackChunkName: 'jobLevel' */ '@/views/businessManagement/jobLevel'),
}
];
